<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.09 12a1 1 0 01-1-1V3a1 1 0 012 0v8a1 1 0 01-1 1z"/><path d="M12.09 22a9 9 0 01-4.5-16.79A1 1 0 019 5.58a1 1 0 01-.37 1.36 7 7 0 107 0 1 1 0 011-1.73A9 9 0 0112.09 22z"/></svg>